// src/services/authService.js
import { supabase } from '../supabaseClient';
import { translateAuthError } from '../utils/errorMessages';  // ✅ CORRIGÉ

/**
 * Service d'authentification avec Supabase
 */

/**
 * Inscription d'un nouvel utilisateur
 * Le profil est créé automatiquement par un trigger PostgreSQL
 */
export const signUp = async (email, password, prenom, nom) => {
  try {
    // Créer l'utilisateur dans auth.users
    // Le trigger handle_new_user() créera automatiquement le profil
    const { data: authData, error: authError } = await supabase.auth.signUp({
      email,
      password,
      options: {
        data: {
          prenom,
          nom
        }
      }
    });

    if (authError) {
      console.error('Erreur signup auth:', authError);
      return { success: false, error: translateAuthError(authError) };
    }

    if (!authData.user) {
      return { success: false, error: 'Erreur lors de la création du compte' };
    }

    console.log('✅ Compte créé:', authData.user.email);
    console.log('✅ Profil créé automatiquement par trigger');
    
    return { 
      success: true, 
      user: authData.user,
      message: 'Compte créé avec succès !'
    };
  } catch (error) {
    console.error('Erreur signUp:', error);
    return { success: false, error: translateAuthError(error) };
  }
};

/**
 * Connexion d'un utilisateur
 */
export const signIn = async (email, password) => {
  try {
    const { data, error } = await supabase.auth.signInWithPassword({
      email,
      password
    });

    if (error) {
      console.error('Erreur signIn:', error);
      return { success: false, error: translateAuthError(error) };
    }

    console.log('✅ Connexion réussie:', data.user.email);
    
    return { 
      success: true, 
      user: data.user,
      session: data.session
    };
  } catch (error) {
    console.error('Erreur signIn:', error);
    return { success: false, error: translateAuthError(error) };
  }
};

/**
 * Déconnexion
 */
export const signOut = async () => {
  try {
    const { error } = await supabase.auth.signOut();

    if (error) {
      console.error('Erreur signOut:', error);
      return { success: false, error: translateAuthError(error) };
    }

    console.log('✅ Déconnexion réussie');
    
    return { success: true };
  } catch (error) {
    console.error('Erreur signOut:', error);
    return { success: false, error: translateAuthError(error) };
  }
};

/**
 * Récupérer l'utilisateur actuellement connecté
 */
export const getCurrentUser = async () => {
  try {
    const { data: { user }, error } = await supabase.auth.getUser();

    if (error) {
      console.error('Erreur getCurrentUser:', error);
      return null;
    }

    return user;
  } catch (error) {
    console.error('Erreur getCurrentUser:', error);
    return null;
  }
};

/**
 * Récupérer la session actuelle
 */
export const getSession = async () => {
  try {
    const { data: { session }, error } = await supabase.auth.getSession();

    if (error) {
      console.error('Erreur getSession:', error);
      return null;
    }

    return session;
  } catch (error) {
    console.error('Erreur getSession:', error);
    return null;
  }
};

/**
 * Réinitialiser le mot de passe
 */
export const resetPassword = async (email) => {
  try {
    const { error } = await supabase.auth.resetPasswordForEmail(email, {
      redirectTo: `${window.location.origin}/reset-password`
    });

    if (error) {
      console.error('Erreur resetPassword:', error);
      return { success: false, error: translateAuthError(error) };
    }

    console.log('✅ Email de réinitialisation envoyé');
    
    return { 
      success: true,
      message: 'Email de réinitialisation envoyé. Vérifiez votre boîte mail.'
    };
  } catch (error) {
    console.error('Erreur resetPassword:', error);
    return { success: false, error: translateAuthError(error) };
  }
};

/**
 * Mettre à jour le mot de passe
 */
export const updatePassword = async (newPassword) => {
  try {
    const { error } = await supabase.auth.updateUser({
      password: newPassword
    });

    if (error) {
      console.error('Erreur updatePassword:', error);
      return { success: false, error: translateAuthError(error) };
    }

    console.log('✅ Mot de passe mis à jour');
    
    return { 
      success: true,
      message: 'Mot de passe mis à jour avec succès'
    };
  } catch (error) {
    console.error('Erreur updatePassword:', error);
    return { success: false, error: translateAuthError(error) };
  }
};

/**
 * Mettre à jour le profil utilisateur (nom, prénom, etc.)
 */
export const updateProfile = async (userId, updates) => {
  try {
    const { error } = await supabase
      .from('profiles')
      .update(updates)
      .eq('id', userId);

    if (error) {
      console.error('Erreur updateProfile:', error);
      return { success: false, error: translateAuthError(error) };
    }

    console.log('✅ Profil mis à jour');
    
    return { 
      success: true,
      message: 'Profil mis à jour avec succès'
    };
  } catch (error) {
    console.error('Erreur updateProfile:', error);
    return { success: false, error: translateAuthError(error) };
  }
};